import React, {memo} from 'react'
import {goBack} from '../../util'
import {withErrorHandling, withHelmet, withMeData, withPropsPresent} from '../../hoc'
import {RemovalConfirmationModal} from '../shared'
import {leaveAccount} from '../../backend'

const _LeaveAccount = (
  {
    account,
    accountId,
    location,
    history,
    navigate,
    leaveAccount,
    mutateMe,
    basePath = '/c/account/accounts'
  }
) => {
  const onRemovalConfirmed = async (account) => {
    const user = await leaveAccount(account)
    if (account.id === accountId) {
      if (!user.accounts.length) {
        navigate('/c/auth/login')
        return
      }
      location.reload()
    } else {
      mutateMe()
      navigate(basePath)
    }

  }

  return (
    <RemovalConfirmationModal
      headerContent={`Please confirm that you'd like to leave the account: ${account.name}`}
      confirmingRemovalOf='account'
      propName='name'
      removalButtonText='Leave'
      expectedPropValue={account.name}
      onRemovalApproved={async () => onRemovalConfirmed(account)}
      onRemovalCancelled={() => goBack(history, navigate, '/c/account/accounts')}/>
  )
}

let LeaveAccount = (props) => {
  const {handleError, me, accountId} = props
  const {accounts = []} = me
  const account = accounts.find(a => a.id === accountId)
  if (!account) {
    props.navigate('/c/account')
    return null
  }
  props = {...props, location: window.location, account, leaveAccount: handleError(leaveAccount)}
  return (<_LeaveAccount {...props}/>)
}

LeaveAccount = withHelmet(LeaveAccount, 'Leave Account')
LeaveAccount = withPropsPresent(LeaveAccount, ['me'])
LeaveAccount = withMeData(LeaveAccount)
LeaveAccount = withErrorHandling(LeaveAccount)
LeaveAccount = memo(LeaveAccount)

export {_LeaveAccount, LeaveAccount}

export default LeaveAccount